const Routes = [
  {
    path: '/physical-stock-counts',
    name: 'PhysicalStockCounts',
    component: () => import('@/app/physical_stock_counts/views/Index'),
    meta: {
      requiresAuth: true
    }
  }
]

export default Routes



// WEBPACK FOOTER //
// ./src/app/physical_stock_counts/Routes.js